
import { ParticleController } from "./ParticleController";
import { BigWinParticleController } from "./BigWinParticleController";
import { ParticleSettings } from "./ParticleSettings";
import { StageLayer } from '@nolimitcity/slot-launcher/bin/StageLayer';
import { ResizeHelper } from "../../../core/utils/ResizeHelper";
import { MathHelper } from "../../../core/utils/MathHelper";

export class ParticlesManager extends PIXI.Container implements StageLayer {

    private _normalParticleC:ParticleController; 


    private _particleBurst:ParticleController[]; 

    private _paperRain:ParticleController; 
    private _moneyRain:ParticleController[]; 
    private _bigWinParticle:BigWinParticleController[] = []; 

    public get allBursts():ParticleController[]{
        return this._particleBurst;
    }

    public moneyRain(lvl:number):ParticleController{
        return this._moneyRain[MathHelper.clamp(lvl,0,this._moneyRain.length-1)];
    }

    public get paperRain():ParticleController{
        return this._paperRain;
    }

    constructor() {
        super();
        this.initAnimations();
        this.onResize();
    }

    protected initAnimations():void {
        this._particleBurst = [];
        this._particleBurst.push(new ParticleController("Big_Win/particles/knife_part", this, ParticleSettings.fountain))
        this._particleBurst.push(new ParticleController("Big_Win/particles/bullet_part", this, ParticleSettings.fountain2))
        this._particleBurst.push(new ParticleController("Particles/Cig", this, ParticleSettings.fountain2))
        this._particleBurst.push(new ParticleController("Big_Win/particles/bullet_part", this, ParticleSettings.fountain2))
        this._particleBurst.push(new ParticleController("Particles/Cig", this, ParticleSettings.fountain_nuts))
        // ParticlesManager._particleBurst.push(new ParticleController("Particles/Cig", this, ParticleSettings.fountain2))
        // ParticlesManager._particleBurst.push(new ParticleController("Particles/Cig", this, ParticleSettings.fountain_nuts))

        this.createRain();
        this._paperRain = new ParticleController("Toapapper", this, ParticleSettings.ManiacWin);
    }

    createRain():void{
        this._moneyRain = [];
        const settings = [ParticleSettings.BigWin];//,ParticleSettings.SuperWin,ParticleSettings.EpicWin,ParticleSettings.MegaWin,ParticleSettings.WickedWin]
        settings.forEach(setting => {
            const part = new ParticleController("flamedPaper", this, setting, false ,12);
            this._moneyRain.push(part);
        })
    }

    onResize():void{
        this.allBursts.forEach(burst => {
            burst.setPos(new PIXI.Point(360 , ResizeHelper.isLandscape ? 660 : 820))
        });

        this._moneyRain.forEach(rain => {
            rain.setPos(new PIXI.Point(-120 , ResizeHelper.isLandscape ? -40 : -280))
        });

        this._paperRain.setPos(new PIXI.Point(360 , ResizeHelper.isLandscape ? 520 : 180));
    }
}